module.exports = __webpack_public_path__ + "img/map-count-icon.685f3d8c.png";